var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "DTOFlyer"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('legend', [_vm._v("Link DTO AWB and Flyer")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Scan AWB")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shippingID),
      expression: "shippingID"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "shippingID",
    class: {
      'form-control': true, 'error': _vm.errors.has('shippingID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Scan AWB",
      "name": "shippingID",
      "id": "shippingID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shippingID)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.nextshippingID.apply(null, arguments)
      }, function($event) {
        return _vm.checkShipmentInput($event)
      }],
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shippingID = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('shippingID')),
      expression: "errors.has('shippingID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("The AWB field is required.")]), _vm._v(" "), (_vm.showIconInput) ? _c('b-form-fieldset', {
    staticStyle: {
      "margin-top": "1%"
    }
  }, [_c('br'), _vm._v(" "), _c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false), [_vm._v(_vm._s(_vm.shippingIDColor))])], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.Weighingrequired !== null) ? _c('b-input-group', {
    staticClass: "d-flex align-items-center p-2 rounded"
  }, [_c('strong', {
    staticClass: "label-text"
  }, [_vm._v("Weighing Required:")]), _vm._v(" "), (!_vm.Weighingrequired) ? _c('span', {
    staticClass: "status-icon success"
  }, [_vm._v("\n    ✔\n  ")]) : _c('span', {
    staticClass: "status-icon danger"
  }, [_vm._v("\n    ✘\n  ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Flyer Barcode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barCode),
      expression: "barCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "barCode",
    class: {
      'form-control': true, 'error': _vm.errors.has('barCode')
    },
    attrs: {
      "type": "text",
      "placeholder": "Scan Flyer Barcode",
      "name": "barCode",
      "id": "barCode"
    },
    domProps: {
      "value": (_vm.barCode)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.onSubmit.apply(null, arguments)
      }, function($event) {
        return _vm.checkShipmentInput($event)
      }],
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.barCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('barCode')),
      expression: "errors.has('barCode')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Flyer Barcode field is required.")])], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" Confirm")]), _vm._v("  \n                ")])], 1)], 1)])])], 1)], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d89f49d","hasScoped":true}!./src/views/components/DTOstickering/DTOFlyer/DTOFlyer.html
// module id = 1881
// module chunks = 2